// generated by bun run generate from the SwiftUI SDK and codegen/catalog.ts.
// edit the generator or catalog, then regenerate.
import type { ViewProps } from 'react-native';
import type { DirectEventHandler, Int32 } from 'react-native/Libraries/Types/CodegenTypes';
import codegenNativeComponent from 'react-native/Libraries/Utilities/codegenNativeComponent';
interface NativeProps extends ViewProps {
  label: string;
  isExpanded: boolean;
  acknowledgedEvent: Int32;
  revision: Int32;
  onNativeDisclosureGroupIsExpandedChange?: DirectEventHandler<Readonly<{
    value: boolean;
    eventCount: Int32;
    revision: Int32;
  }>>;
}
const NativeComponentRegistry = require('react-native/Libraries/NativeComponent/NativeComponentRegistry');
const {
  ConditionallyIgnoredEventHandlers
} = require('react-native/Libraries/NativeComponent/ViewConfigIgnore');
let nativeComponentName = 'OneNativeDisclosureGroup';
export const __INTERNAL_VIEW_CONFIG = {
  uiViewClassName: "OneNativeDisclosureGroup",
  directEventTypes: {
    topNativeDisclosureGroupIsExpandedChange: {
      registrationName: "onNativeDisclosureGroupIsExpandedChange"
    }
  },
  validAttributes: {
    label: true,
    isExpanded: true,
    acknowledgedEvent: true,
    revision: true,
    ...ConditionallyIgnoredEventHandlers({
      onNativeDisclosureGroupIsExpandedChange: true
    })
  }
};
export default NativeComponentRegistry.get(nativeComponentName, () => __INTERNAL_VIEW_CONFIG);